import React from 'react';
import { TableCell, TableRow} from '@mui/material';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import {OutlinedInput, MenuItem, Chip, Stack} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import styled from 'styled-components';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const ButtonWrapper = styled.div`
  display: flex;
`


const OTEditableRow = ({k,row, editFormData, handleCancelClick,
   page, rowsPerPage, onChangeEditOffType, designations, SubmitButton}) =>{
    return( <>
      <TableRow key={k} name={row.Category}>
        <TableCell component="th" scope="row">
          {(page)*(rowsPerPage)+k+1}
        </TableCell>
          
        <TableCell  align="left">
          <TextField
              id="outlined-basic"
              size='small'
              type="text"
              name={`officetype${(page)*(rowsPerPage)+k}`}
              onChange={(event, newValue) => onChangeEditOffType(event, newValue)}
              label="Office Type"
              value={editFormData[`officetype${(page)*(rowsPerPage)+k}`]}
              variant="outlined"
              sx={{backgroundColor:"white", width:"200px", height:"40px"}}
            />
        </TableCell>

        <TableCell  align="left">
          <Autocomplete
              disablePortal
              id="combo-box-demo"
              size='small'
              value={editFormData[`level${(page)*(rowsPerPage)+k}`]}
              onChange={(event, newValue) => onChangeEditOffType(event, newValue, `level${(page)*(rowsPerPage)+k}`)}
              options={Array(20).fill("level").map((item, index) => `${item}${index+1}`)}
              sx={{backgroundColor:"white", width:"200px", marginLeft:"20px", marginRight:"20px",height:"40px"}}
              renderInput={(params) => <TextField {...params} label={"Level"} />}
            />
        </TableCell>     
          
        <TableCell  align="left">
          {console.log(editFormData[`unitheaddesignations${(page)*(rowsPerPage)+k}`])}
          <Autocomplete
            multiple
            id="combo-box-demo"
            size='small'
            options={designations? (Object.values(designations)?.map(x => x.name )) : []}
            sx={{backgroundColor:"white", width:"100%", height:"40px"}}
            value={editFormData[`unitheaddesignations${(page)*(rowsPerPage)+k}`]}
            onChange={(event, newValue) =>onChangeEditOffType(event, newValue, `unitheaddesignations${(page)*(rowsPerPage)+k}`)}
            renderInput={(params) => ( 
              <TextField
                {...params}
                variant="outlined"
                label="Unit Head Designations"
              />
            )}
          />                        
        </TableCell>           
        {/* marginLeft:"20px", marginRight:"20px", */}
        <TableCell align="left">
          <ButtonWrapper>
            <SubmitButton style={{marginRight:'10px'}} type="submit">Save</SubmitButton>
            <SubmitButton style={{marginRight:'10px'}} type="button" onClick={(e)=>handleCancelClick(e,k)}
            >Cancel</SubmitButton>
          </ButtonWrapper>                         
    </TableCell>
  </TableRow>     
        </>         
    )
}

export default OTEditableRow;